<template lang="pug">
.sv-input__wrapper
    label.sv-input__label(
      v-if="label"
    )
      | {{ label }}

    input.sv-input(
        v-if="mask === 'numeric'"
        v-mask="'9{*}'"
        v-bind="$attrs"
        :class="classes"
        @input="target"
        @blur="blur"
        @focus="focus"
    )

    input.sv-input(
        v-if="mask === 'percent'"
        v-mask="{regex: '^([0-9]{1,2})([.,][0-9]{1,2})?$', placeholder: '', showMaskOnHover: false, showMaskOnFocus: false}"
        v-bind="$attrs"
        :class="classes"
        @input="target"
        @blur="blur"
        @focus="focus"
    )


    input.sv-input(
        v-if="customMask"
        v-mask="customMask"
        v-bind="$attrs"
        :class="classes"
        @input="target"
        @blur="blur"
        @focus="focus"
    )


    input.sv-input(
        v-if="!mask && !customMask"
        v-bind="$attrs"
        :class="classes"
        ref="svInput"
        @input="target"
        @blur="blur"
        @focus="focus"
        @keyup.enter="enter"
    )

    span.sv-input__error-text(
        v-if="error"
    )
        | {{ error }}

    .sv-input__append-icon(
      v-if="withIcon"
    )
        IconSearch.sv-input__icon
</template>

<script>
import IconSearch from '@/components/icons/IconSearch.vue';

export default {
  name: 'SvInput',

  components: {
    IconSearch,
  },

  props: {

    customMask: {
      type: Object,
      default: null
    },

    mask: {
      type: String,
      default: '',
    },

    label: {
      type: String,
      default: '',
    },

    color: {
      type: String,
      default: 'white',
    },

    error: {
      type: String,
      default: '',
    },

    size: {
      type: String,
      default: 'normal',
    },

    withIcon: {
      type: Boolean,
      default: true,
    },

    initAutofocus: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    'initAutofocus': function(newVal, oldVal) {
      if (!oldVal && newVal && this.initAutofocus) {
        this.$refs.svInput.focus();
      }
    }
  },

  mounted() {

  },

  methods: {
    target(val) {
      if (this.mask === 'numeric') {
        this.$emit('input', Number(val.target.value));
        return;
      }
      if (this.mask === 'percent') {
        const value = val.target.value.replace('.',',');
        this.$emit('input', value);
        return;
      }
      this.$emit('input', val.target.value);
    },

    blur(val) {
      if (this.mask === 'numeric') {
        this.$emit('blur', Number(val.target.value));
        return;
      }
      this.$emit('blur', val.target.value);
    },

    focus(val) {
      if (this.mask === 'numeric') {
        this.$emit('focus', Number(val.target.value));
        return;
      }
      this.$emit('focus', val.target.value);
    },

    enter(val) {
      this.$emit('enter', val.target.value);
    }
  },

  computed: {
    classes() {
      return {
        'sv-input_large': this.size === 'large',
        'sv-input_gray-light': this.color === 'graylight',
        'sv-input_error': this.error,
      };
    },
  },
};
</script>

<style lang="scss">
.sv-input__wrapper {
    position: relative;
    &._full-width {
        width: 100%;
    }
}

.sv-input {
    border: 0;
    padding: 0;
    width: 100%;
    border-radius: 5px;
    height: 40px;
    transition: background-color ease-in-out .2s;
    background-color: #F3F3F6;
    padding-left: 21px;
    outline: none;
    font-size: 14px;
    line-height: 100%;
    color: #404450;
    font-weight: 500;

    &__label {
      line-height: 28px;
      color: #404450;
      font-size: 14px;
      font-weight: 500;
    }

    &__icon {
        stroke: #ADB1BC;
    }

    &_large {
        height: 60px;
        padding-left: 34px;
        padding-right: 68px;
        border-radius: 50px;

        & + .sv-input__error-text {
            left: 34px;
        }

        .sv-input__icon {
            stroke: #B7BAC6;
        }

        &:focus + .sv-input__append-icon .sv-input__icon {
            stroke: #1993EB;
        }
    }

    &__append-icon {
        position: absolute;
        right: 24px;
        top: calc(50% - 9px);
    }

    &_gray-light {
        background-color: #F3F3F6;
    }

    &::placeholder {
        color: #ADB2C0;
    }

    &:focus {
        box-shadow: 0px 2px 10px rgba(10, 110, 183, 0.15);
        background-color: #fff;
    }

    &_error {
        border: 1px solid #EC9393;
    }

    &__error-text {
        position: absolute;
        margin-top: 5px;
        color: #D74848;
        font-size: 12px;
        top: 100%;
        left: 21px;
    }
}
</style>
